export const registerFormSteps = {
  CONTACT_INFORMATION: 0,
  ADDRESS_DATA: 1,
  BANK_DATA: 2,
  CONTACT_CONFIRMATION: 10,
};

export const providerRelation = [
  'CREDITOR',
  'CUSTOMER',
  'DEBTOR',
  'PARENT_COMPANY',
  'SUPPLIER',
  'OTHER',
];

export const USA_DIGITS_ACCOUNT_MIN = 5;
export const USA_DIGITS_ACCOUNT_MAX = 17;
export const USA_DIGITS_ROUTING = 9;
export const USA_DIGITS_TAX = 9;
export const MX_DIGITS_RFC = 13;
export const MX_DIGITS_CLABE = 18;
export const COL_DIGITS_ACCOUNT = 9;
export const ADDRESS_MAX_LENGTH = 60;
export const BANK_NAME_MAX_LENGTH = 150;
export const CITY_MAX_LENGTH = 60;
export const STATE_MAX_LENGTH = 60;
export const POST_CODE_MAX_LENGTH = 15;

export const BANCO_AZTECA = '127';
export const BANCO_AZTECA_NAME = 'Banco Azteca';

export const UNSUPPORTED_BANKS = [
  {
    code: BANCO_AZTECA,
    name: BANCO_AZTECA_NAME,
  },
] as const;

export const regexReplaceEmptySpaces = /\s\s+/g;

export const COUNTRIES_IN_EUROPE = [
  'AL',
  'AD',
  'AM',
  'AT',
  'AZ',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'GE',
  'DE',
  'GR',
  'HU',
  'IS',
  'IE',
  'IT',
  'KZ',
  'XK',
  'LV',
  'LI',
  'LT',
  'LU',
  'MT',
  'MD',
  'MC',
  'ME',
  'NL',
  'MK',
  'NO',
  // 'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'TR',
  'UA',
  'VA',
];

export enum CountriesToShowDefaultCurrency {
  GB = 'GB',
  CN = 'CN',
  AU = 'AU',
  PL = 'PL',
  JP = 'JP',
}

export enum BlockedCountries {
  DO = 'DO',
}
